import React from 'react';
import { Label } from 'semantic-ui-react';
import { formatCurrency } from '../services';

/**
 * HygienistPayAsterisk Component
 * 
 * Displays hygienist pay contribution with asterisk notation (*$XXX.XX*).
 * Only renders when shouldDisplay is true (hygienist billable care > 0).
 * 
 * @component
 * @param {object} props - Component props
 * @param {number} props.calculatedPay - Calculated hygienist pay contribution
 * @param {boolean} props.shouldDisplay - Whether to display the asterisk
 * @returns {JSX.Element|null} Label with asterisk notation or null
 * 
 * @example
 * <HygienistPayAsterisk 
 *   calculatedPay={300.00}
 *   shouldDisplay={true}
 * />
 * // Renders: *$300.00*
 */
const HygienistPayAsterisk = ({ 
    calculatedPay,
    shouldDisplay
}) => {
    // Don't render if shouldDisplay is false (hygBillableCare <= 0) or calculatedPay <= 0
    if (!shouldDisplay || calculatedPay <= 0) {
        return null;
    }
    
    return (
        <>
            <br />
            <Label 
                content={`*${formatCurrency(calculatedPay)}*`} 
                basic={true} 
                className="mt-1" 
                title={`Hygienist Pay Contribution: ${formatCurrency(calculatedPay)}`}
            />
        </>
    );
};

export default HygienistPayAsterisk;
